// 1_utils/measure_units_download.js
// Exposes window.NAT.utils.downloadAndSaveMeasureUnitFilter(): fetches the
// measure-unit filter JSON (URL from translations), caches it in localStorage for
// 24h, and publishes the result on window.NAT.measureFiltersData for the
// measure_units_show component to read.

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};
window.NAT.measureFiltersData = window.NAT.measureFiltersData || [];

window.NAT.utils.downloadAndSaveMeasureUnitFilter = async function downloadAndSaveMeasureUnitFilter() {
	const url = window.NAT.translations("gitFiltersUrl");
	const storageKey = "measureFilters";
	const expiryKey = "measureFilters_expiry_01";

	// Check if data is already in localStorage and not expired
	const now = Date.now();
	const expiry = localStorage.getItem(expiryKey);
	const cached = localStorage.getItem(storageKey);
	if (expiry && cached && now < parseInt(expiry)) {
		// Data is still valid
		console.log("Measure filters loaded from localStorage.");
		window.NAT.measureFiltersData = JSON.parse(cached);
		return;
	}

	// Fetch and save
	try {
		const response = await fetch(url);
		if (!response.ok) throw new Error("Network response was not ok");
		const data = await response.json();
		localStorage.setItem(storageKey, JSON.stringify(data));
		localStorage.setItem(expiryKey, (now + 24 * 60 * 60 * 1000).toString());
		console.log("Measure filters saved to localStorage.");
		window.NAT.measureFiltersData = data;
	} catch (error) {
		console.warn("Failed to fetch Measure filters:", error);
	}
};
